import React from 'react';

const MoreThan24HourNoReentry = () => (
  <p className="text-color-medium-grey text-size-20 text-weight-book" key="24-hour-notice">
    You've booked for more than 24 hours. This location doesn't allow you to enter and exit more than once.
  </p>
);

export default MoreThan24HourNoReentry;
